import React from 'react';
import { useAccount } from 'catering/context/providers/AccountProvider';
import LocationOffline from 'components/Location/LocationOffline';

function LocationOfflineScreen() {
  const { logoDestinationUrl } = useAccount();
  const title = 'Ordering is currently unavailable';
  return (
    <LocationOffline logoDestinationUrl={logoDestinationUrl} title={title} />
  );
}

export default LocationOfflineScreen;
